import { render, staticRenderFns } from "./input-widget.vue?vue&type=template&id=add7e97c&scoped=true"
import script from "./input-widget.vue?vue&type=script&lang=js"
export * from "./input-widget.vue?vue&type=script&lang=js"
import style0 from "./input-widget.vue?vue&type=style&index=0&id=add7e97c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add7e97c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('add7e97c')) {
      api.createRecord('add7e97c', component.options)
    } else {
      api.reload('add7e97c', component.options)
    }
    module.hot.accept("./input-widget.vue?vue&type=template&id=add7e97c&scoped=true", function () {
      api.rerender('add7e97c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/input-widget.vue"
export default component.exports